import { PLATFORM_MONTH_FORMAT } from "./constants";
import { parseDateString } from "./parse-date-string";
export var daysInMonthString = function (month) {
  var date = parseDateString(month, PLATFORM_MONTH_FORMAT);
  if (!date) {
    return 0;
  }
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
};